import "rsuite/DateRangePicker/styles/index.css";

import { useEffect, useState } from "react";

import { getExceptionList } from "~/services/supervisor.services";

import ExceptionTable from "./table";

const ExceptionComponent = () => {
  const [status, setStatus] = useState<any>({});
  const [activeTab, setActiveTab] = useState<number>(0);
  const [activeData, setActiveData] = useState<string>("");
  const [worklistData, setWorklistData] = useState<any>(null);

  const roleId = localStorage.getItem("roleid");

  useEffect(() => {
    fetchData();
  }, []);

  console.log(activeTab);

  const onSubmitModal = async () => {
    if (roleId === "8") {
      void fetchData();
    }
  };

  const fetchData = async () => {
    const { data, status } = await getExceptionList();

    console.log(data);

    console.log("Fetched data:", data);
    if (status) {
      const dataArray = (data as any)?.data;

      if (data && (data as any)?.data?.length === 0) {
        setWorklistData([]);
        setStatus({});
        setActiveData("All");
      } else {
        setWorklistData(dataArray);

        const allStatus: any = { All: (data as any)?.data };
        dataArray.forEach((d: any) => {
          if (d.Status in allStatus) {
            allStatus[d.Status].push(d);
          } else {
            allStatus[d.Status] = [];
            allStatus[d.Status].push(d);
          }
        });
        setStatus(allStatus);
        const firstKey = Object.keys(allStatus as object)[0] || "";
        setActiveData(firstKey);
        setActiveTab(Object.keys(allStatus as object).indexOf(firstKey));
      }
    } else {
      console.error("Failed to fetch data, status not ok");
    }
  };

  return (
    <div className="">
      {worklistData != null && (
        <>
          <div className="flex justify-between items-center mb-3">
            <h4 className="text-2xl font-semibold text-orange-500">
              Exception Dashboard
            </h4>
          </div>
          <div className="bg-neutral-100 rounded-lg">
            <div className="p-2">
              {Boolean(status) &&
              activeData &&
              Boolean(status[activeData]) &&
              status[activeData].length > 0 ? (
                <ExceptionTable
                  data={status[activeData]}
                  onSubmit={onSubmitModal}
                />
              ) : (
                <div className="p-3 font-semibold">
                  No record found.
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ExceptionComponent;
